export default {
  FETCH_MY_PROSPECTS_START: 'FETCH_MY_PROSPECTS_START',
  FETCH_MY_PROSPECTS_SUCCESS: 'FETCH_MY_PROSPECTS_SUCCESS',
  FETCH_MY_PROSPECTS_FAILURE: 'FETCH_MY_PROSPECTS_FAILURE',

  TRACK_ADD_TOP_CHOICES_START: 'TRACK_ADD_TOP_CHOICES_START',
  TRACK_ADD_TOP_CHOICES_SUCCESS: 'TRACK_ADD_TOP_CHOICES_SUCCESS',
  TRACK_ADD_TOP_CHOICES_FAILURE: 'TRACK_ADD_TOP_CHOICES_FAILURE',

  TRACK_REMOVE_TOP_CHOICES_START: 'TRACK_REMOVE_TOP_CHOICES_START',
  TRACK_REMOVE_TOP_CHOICES_SUCCESS: 'TRACK_REMOVE_TOP_CHOICES_SUCCESS',
  TRACK_REMOVE_TOP_CHOICES_FAILURE: 'TRACK_REMOVE_TOP_CHOICES_FAILURE',

  TRACK_REORDER_TOP_CHOICES_START: 'TRACK_REORDER_TOP_CHOICES_START',
  TRACK_REORDER_TOP_CHOICES_SUCCESS: 'TRACK_REORDER_TOP_CHOICES_SUCCESS',
  TRACK_REORDER_TOP_CHOICES_FAILURE: 'TRACK_REORDER_TOP_CHOICES_FAILURE',

  SET_TOP_CHOICES_START: 'SET_TOP_CHOICES_START',
  SET_TOP_CHOICES_SUCCESS: 'SET_TOP_CHOICES_SUCCESS',
  SET_TOP_CHOICES_FAILURE: 'SET_TOP_CHOICES_FAILURE',

  TOGGLE_FOLLOW_START: 'TOGGLE_FOLLOW_START',
  TOGGLE_FOLLOW_SUCCESS: 'TOGGLE_FOLLOW_SUCCESS',
  TOGGLE_FOLLOW_FAILURE: 'TOGGLE_FOLLOW_FAILURE',
}
